module.exports = __webpack_public_path__ + "static/a43428ecaf4380b73ff0dd4326677b1b.png";